import useUnifiedUtilizationQueryParams from './useUnifiedUtilizationQueryParams';

// Backwards compatible wrapper preserving original signature.
export default function useUtilizationQueryParams(
  params: Parameters<typeof useUnifiedUtilizationQueryParams>[0]
) {
  return useUnifiedUtilizationQueryParams({ ...params, useTrailingLag: true });
}
